import React, { useEffect, useState } from 'react';

/**
 * Verstecktes Easter Egg: Strg+AltGr+O zeigt kurz ein Status-Bild unseres
 * internen KI-Servers vollflächig an (20 Sekunden), dann verschwindet es
 * wieder. Rein clientseitig, kein Zugriff auf interne Systeme von hier aus -
 * das Bild wird extern (stuendlich) nach /easter-egg/status.png kopiert,
 * diese Komponente zeigt nur die aktuellste Version davon.
 *
 * Pruefung ueber e.code (physische Tastenposition) statt e.key: auf
 * deutschen Tastaturen erzeugt AltGr+E z.B. "€" statt "e" - e.key haette
 * den Trigger nie erkannt. e.code bleibt unabhaengig vom Tastaturlayout.
 */
const EasterEgg = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.altKey && e.code === 'KeyO') {
        setVisible(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    const timer = setTimeout(() => setVisible(false), 20000);
    return () => clearTimeout(timer);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      onClick={() => setVisible(false)}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        animation: 'easterEggFadeIn 0.15s ease-out',
      }}
    >
      <style>{`
        @keyframes easterEggFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
      <img
        src={`/easter-egg/status.png?t=${Date.now()}`}
        alt=""
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    </div>
  );
};

export default EasterEgg;
